<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Cartes de fidélité</h1>
                    <p>Gestion des cartes de fidélité</p>
                </div>

                <div class="actions">
                    <ul>
                        <!--<li><button><span>Importer</span></button></li>-->
                        <li><button-action type="export"/></li>
                        <li><button-action  type="create"/></li>
                    </ul>
                </div>

            </div>
        </header>
        <div class="content-body">

            <section>
            <div class="search">
                <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                <!--
                <div>
                    <ul>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                    </ul>
                </div>
                -->
            </div>

            <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

            <div class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'person.firstname' ? 'active' : '', paginator.order ]">
                            <span data-sort="person.firstname" @click="setOrder($event)">Détenteur</span>
                        </div>
                        <div class="center" v-bind:class="[ paginator.sort == 'amount_total' ? 'active' : '', paginator.order ]">
                            <span data-sort="amount_total" @click="setOrder($event)">Total</span>
                        </div>
                        <div class="center" v-bind:class="[ paginator.sort == 'amount_available' ? 'active' : '', paginator.order ]">
                            <span data-sort="amount_available" @click="setOrder($event)">Restant</span>
                        </div>
                        <div><span>Scope</span></div>
                        <div><span>Statut</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_card"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="person.firstname">
                            <strong v-if="item.person">{{ item.person.firstname }} {{ item.person.lastname }}</strong>
                            <strong v-if="!item.person">Anonyme</strong>
                        </div>
                        <div class="center" data-field="amount_total">{{ currency }} {{ item.amount_total|formatNumber }}</div>
                        <div class="center" data-field="amount_available">{{ currency }} {{ item.amount_available|formatNumber }}</div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="status"><active v-model="item.user.active" v-if="item.user"></active></div>
                        <div class="actions">
                            <ul>
                                <li v-if="item.policies && item.policies.delete"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="item.policies && item.policies.update"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import AccountService from './AccountService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                currency: null
            }
        },
        mounted: function(){
            this.currency = this.$store.state.scope.currency_id
            this.refresh()
        },
        methods: {
            getResource: function(){
                return AccountService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/fidelity/account/Index.vue